import moment from 'moment-timezone'

const TIMEZONE = 'Asia/Singapore'

// Calendar days in Singapore time, both inclusive. Compared as dates rather than
// `new Date('12 Oct 2026')`, which parses in the visitor's own timezone and would
// switch the banner at the wrong hour for anyone outside Singapore.
export const FESTIVE_BANNER_START_DATE = '2026-10-12'
export const FESTIVE_BANNER_END_DATE = '2026-12-27'
// Staging opens the window early so the festive banner can be checked there
// before it launches on production.
export const STAGING_FESTIVE_BANNER_START_DATE = '2026-10-01'

export function isFestiveBannerActive(now = moment(), environment = process.env.VUE_APP_ENVIRONMENT) {
  const today = moment(now).tz(TIMEZONE).format('YYYY-MM-DD')
  const startDate = environment === 'staging' ? STAGING_FESTIVE_BANNER_START_DATE : FESTIVE_BANNER_START_DATE
  return today >= startDate && today <= FESTIVE_BANNER_END_DATE
}
